/** @module Query hook for the backend readiness endpoint. */
import { useQuery } from "@tanstack/react-query";

import { api, ApiError } from "@/api/client";
import type { components } from "@/api/client";

export type Readiness = components["schemas"]["ReadyResponse"];

function isReadiness(value: unknown): value is Readiness {
  return typeof value === "object" && value !== null && "checks" in value;
}

export function useReadiness() {
  return useQuery<Readiness>({
    queryKey: ["health", "ready"],
    refetchInterval: 30_000,
    queryFn: async ({ signal }) => {
      const { data, error, response } = await api.GET("/api/v1/health/ready", { signal });
      if (data) return data;
      // 503 carries the same body, so a failing dependency is data, not an error.
      if (response.status === 503 && isReadiness(error)) return error;
      throw ApiError.from(response.status, error);
    },
  });
}
